import * as React from "react";
import { cn } from "../shared/ui/index.ts";

export function ActivityWidget() {
  const days = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];
  const data = [12, 18, 15, 22, 14, 8, 0];
  const max = Math.max(...data);
  const chartH = 72;

  return (
    <div>
      <div className="mb-3.5 flex items-baseline gap-2">
        <div className="text-[26px] font-bold tracking-tight">89</div>
        <div className="text-xs text-sf-text-muted">
          consultations cette semaine
        </div>
      </div>
      <div className="grid h-[100px] grid-cols-7 gap-2 items-end">
        {data.map((v, i) => {
          const innerH =
            max > 0 ? Math.max(Math.round((v / max) * chartH), 4) : 4;
          const today = i === 0;
          return (
            <div
              key={i}
              className="flex h-full min-h-0 flex-col items-center gap-1.5"
            >
              <div className="flex min-h-0 w-full flex-1 flex-col justify-end">
                <svg
                  width="100%"
                  height="100%"
                  viewBox={`0 0 20 ${chartH}`}
                  preserveAspectRatio="xMidYMax meet"
                  className="max-h-full min-h-[4px]"
                  aria-hidden
                >
                  <rect
                    x="4"
                    y={chartH - innerH}
                    width="12"
                    height={innerH}
                    rx="4"
                    className={cn(
                      today ? "fill-sf-primary" : "fill-sf-primary-100",
                    )}
                  />
                </svg>
              </div>
              <div
                className={cn(
                  "text-[10.5px]",
                  today
                    ? "font-semibold text-sf-primary"
                    : "font-medium text-sf-text-muted",
                )}
              >
                {days[i]}
              </div>
              <div className="text-[11px] font-semibold tabular-nums text-sf-text">
                {v}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// --- Premiers contacts à traiter ---
